import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { useAiChat } from '@factorialco/f0-react'

import './index.styles.css'

interface FiltersWrapperProps {
  children: React.ReactNode
}

export const FiltersWrapper: React.FC<FiltersWrapperProps> = ({ children }) => {
  const { open: isChatOpen } = useAiChat()

  return (
    <Box paddingBottom="s16">
      <Box background="white" className={!isChatOpen ? 'FiltersWrapper_stickyFilters' : undefined}>
        {children}
      </Box>
    </Box>
  )
}
